// ICF Guide reducer
import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  icfList: [],
  query: '',
  isIcfSelected: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_ICF_CONTENTS:
      return Object.assign({}, state, {
        isLoading: true,
        error: false,
        icfList: [],
        query: action.payload,
      });
    case types.RECEIVED_ICF_CONTENTS:
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        icfList: action.payload,
      });
    case types.RECEIVED_ICF_CONTENTS_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: true,
        icfList: [],
      });
    default:
      return state;
  }
}
